import React, { useRef, useState, useEffect, useCallback } from "react";
import { debounce } from "lodash";
import styles from "./Dropdown.module.scss";

export const useDropdown = () => {
  const [open, setOpen] = useState(false);
  const [below, setBelow] = useState(true);
  const dropdownBody = useRef<HTMLDivElement>(null);
  const dropdownBtn = useRef<HTMLDivElement>(null);

  const closeDropdown = () => {
    const body = dropdownBody?.current;
    if (!body) return;
    setOpen(false);
    setBelow(true);
    body.scrollTop = 0;
  };

  const openDropdown = () => {
    const body = dropdownBody?.current;
    if (!body) return;
    setOpen(true);
    const selectedElem = dropdownBody.current.querySelector("." + styles.linkSelected);
    if (!selectedElem) return;
    setTimeout(() => {
      const body = dropdownBody?.current;
      if (!body) return;
      const diff =
        body.getBoundingClientRect().top - selectedElem.getBoundingClientRect().top - body.scrollTop + 5;
      body.scrollTop = -1 * diff;
    }, 0);
  };

  const onBtnClick = () => {
    open ? closeDropdown() : openDropdown();
  };

  const checkDropdownPosition = () => {
    const body = dropdownBody?.current;
    if (!body || !dropdownBtn.current) return;
    const winTop = window.scrollY;
    const elHeight = body.clientHeight;
    const elTop = winTop + body.getBoundingClientRect().top;

    const result =
      elTop + elHeight <= winTop + window.innerHeight && elTop + elHeight < document.body.clientHeight;

    setBelow(result);
  };

  const debouncedCheckDropdownPosition = debounce(checkDropdownPosition, 100);

  const onDocClick = useCallback((event: any) => {
    const btnRef = dropdownBtn?.current;
    const bodyRef = dropdownBody?.current;
    if (!btnRef || !bodyRef) return;
    if (btnRef === event.target || btnRef.contains(event.target)) return;
    if (!bodyRef.contains(event.target)) closeDropdown();
  }, []);

  useEffect(checkDropdownPosition, [open, dropdownBody]);

  useEffect(() => {
    document.addEventListener("click", onDocClick);
    window.addEventListener("scroll", debouncedCheckDropdownPosition);
    window.addEventListener("resize", debouncedCheckDropdownPosition);

    return () => {
      document.removeEventListener("click", onDocClick);
      window.removeEventListener("scroll", debouncedCheckDropdownPosition);
      window.removeEventListener("resize", debouncedCheckDropdownPosition);
    };
  }, [debouncedCheckDropdownPosition, onDocClick]);

  return {
    open,
    below,
    onBtnClick,
    closeDropdown,
    dropdownBtn,
    dropdownBody,
  };
};
